import {Flag} from 'platform/components';
import {Box, Clickable, ClickableProps, HStack, Image, Show, Spinner} from 'platform/foundation';

import {MouseEvent} from 'react';

import {pickAll} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface VehicleAlbumImageProps extends Omit<ClickableProps, 'children'>, TestIdProps {
  src: string;
  isLoading?: boolean;
  isCoverPhoto?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

const getClickableProps = pickAll([
  'isDisabled',
  'onClick',
  'onMouseWheelClick',
  'onContextMenu',
  'onMouseEnter',
  'onMouseLeave',
  'role',
]);

export function VehicleAlbumImage(props: VehicleAlbumImageProps) {
  const clickableProps = getClickableProps(props) satisfies ClickableProps;

  return (
    <Clickable
      data-testid={suffixTestId('vehicleAlbumImage', props)}
      {...clickableProps}
      onClick={(event) => {
        event.preventDefault();
        props.onClick?.(event);
      }}
      onContextMenu={(event) => {
        event.preventDefault();
        props.onContextMenu?.(event);
      }}
      isDisabled={props.isDisabled || props.isLoading}
    >
      <Box position="relative">
        <Box
          ratio="4 / 3"
          width="100%"
          overflow="hidden"
          position="relative"
          border="3px solid"
          borderColor="general.transparent"
          borderRadius="small"
        >
          <Image
            data-testid={suffixTestId('vehicleAlbumImage', props)}
            width="100%"
            height="100%"
            draggable={false}
            borderRadius="small"
            src={props.src}
            fit="cover"
            hasSpinner
          />
          <Show when={props.isLoading}>
            <Spinner data-testid={suffixTestId('vehicleAlbumImage', props)} variant="overlay" />
          </Show>
          <Show when={props.isCoverPhoto}>
            <Box position="absolute" top={0} right={0} padding={2}>
              <HStack spacing={1}>
                <Flag
                  data-testid={suffixTestId('isCoverPhoto-flag', props)}
                  label={i18n.t('entity.photo.labels.coverPhoto')}
                  colorScheme="blue"
                  isSubtle
                  size="small"
                />
              </HStack>
            </Box>
          </Show>
        </Box>
      </Box>
    </Clickable>
  );
}
